export const columns = ({ t }) => [
  {
    title: t('Last Name'),
    name: 'lastName'
  },
  {
    title: t('First Name'),
    name: 'firstName'
  },
  {
    title: t('Role'),
    name: 'role'
  },
  {
    title: t('Phone Number'),
    name: 'phone'
  },
  {
    title: t('Email Address'),
    name: 'email'
  }
];

export const formatData = (users, roles) =>
  users.map(user => ({
    id: user.id,
    firstName: user.firstName,
    lastName: user.lastName,
    role: roles.find(role => role.enumValue === user.roleId).name,
    phone: user.phone,
    email: user.email
  }));

export default {
  columns,
  formatData
};
